"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeechlyUiEvents = void 0;
var SpeechlyUiEvents;
(function (SpeechlyUiEvents) {
    SpeechlyUiEvents["TangentClick"] = "TangentClick";
})(SpeechlyUiEvents = exports.SpeechlyUiEvents || (exports.SpeechlyUiEvents = {}));
;
//# sourceMappingURL=types.js.map